import React from 'react';
import './ExportButton.style.scss';
import { useSelector } from 'react-redux';
import store, { RootState } from '../../../../Redux/Store/store';
import { AddAnimationPayloadInterface } from '../../../../Redux/Actions/Animator/animation.list.action';
import * as JSZIP from 'jszip';

const ExportButton = (props: any) => {
    const JSZip = require('jszip');
    const zip: JSZIP = new JSZip();
    const animation_list = useSelector((state: RootState) => state.AnimationList);
    const handleClick = async () => {
        const atlas_name = store.getState().atlasAnim.image.name;
        const anim_json = {
            anims: animation_list.animations.map((animation: AddAnimationPayloadInterface) => {
                return {
                    key: animation.name,
                    type: "frames",
                    repeat: animation.key_controls.repeat,
                    frameRate: animation.key_controls.frame_rate,
                    frames: animation.frames.map((frame: any) => {
                        return {
                            key: atlas_name,
                            frame: frame.name
                        }
                    })
                }
            })
        };
        zip.file(`${atlas_name}_anim.json`, JSON.stringify(anim_json, null, '    '));
        const file = await zip.generateAsync({ type: 'blob' });
        saveAs(file, `${atlas_name}_anim.zip`);
    }

    return (
        <React.Fragment>
            {
                (animation_list.animations.length < 1)
                    ?
                    <button className={`save-export-disable noselect`}>
                        {props.title}
                    </button>
                    :
                    <button className={`save-export noselect`} onClick={handleClick}>
                        {props.title}
                    </button>
            }
        </React.Fragment>
    )
}

export default ExportButton;
